const Shimmer = ()=>{
   return( <div className="restrocard shimmercard">
    <div className="shimmer-img"></div>
    <div className="shimmer-heading-container"></div>
    <div className="shimmer-text-container"></div>
    <div className="shimmer-text-container"></div>
    
    </div>
)
}
export default Shimmer;